import React from 'react';

export default ({ width = 40, height = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg6"
    version="1.1"
    width={width}
    height={height}
    viewBox="0 0 512 512"
  >
    <defs id="defs10" />
    <g id="g4">
      <path
        id="path2"
        transform="matrix(0.8,0,0,0.8,51.2,51.2)"
        d="m 367.717,25.318 c -287.811333,367.12133 -143.90567,183.56067 0,0 z m -113.205,105.888 -58.035,73.85 118.628,88.885 c 0,0 3.513,2.384 5.48,5.904 2.02,3.612 1.81,6.935 1.81,6.935 V 435.324 H 297.14 v -24.56 H 89.255 v 24.56 H 61.51 v 59.358 H 432.963 V 338.184 c 0.47954,-83.68005 -19.70525,-81.50909 -63.019,-116.861 L 254.51,131.206 Z M 403.146,231.46 c -311.430667,229.69333 -155.71533,114.84667 0,0 z"
      />
    </g>
  </svg>
);
